import { createWebHistory, createRouter } from "vue-router"

const routes = [
    {
        path: "/",
        name: 'Main',
        component: () => import('@/components/Main.vue')
    },
    {
        path: "/sign",
        name: 'SignIn',
        component: () => import('@/components/auth/SignIn')
    },
    {
        path: "/sign/change",
        name: 'PasswordChange',
        component: () => import('@/components/auth/PasswordChange')
    },
    {
        path: "/sign/reset",
        name: 'PasswordReset',
        component: () => import('@/components/auth/PasswordReset')
    },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
